import request from '@/utils/request';

const path = 'api/v1';

export const userLogin = (data?: object) => request({
  url: `${path}/login`,
  method: 'POST',
  data,
});

export const userLogout = (data?: object) => request({
  url: `${path}/logout`,
  method: 'Delete',
  data,
});

export const userInfoGET = (data?: object) => request({
  url: `${path}/user/0`,
  method: 'Get',
  data,
});

export const webCodeAcquire = (data?: object) => request({
  url: `${path}/user/webCodeAcquire`,
  method: 'Get',
  params: data,
});

export const webCodeCheckLogin = (data?: object) => request({
  url: `${path}/user/webCodeCheckLogin`,
  method: 'Get',
  params: data,
});

export const countryList = (data?: object) => request({
  url: `${path}/defines/countryList`,
  method: 'Get',
  params: data,
});

export const userListGET = (data?: object) => request({
  url: `${path}/user`,
  method: 'Get',
  params: data,
});

export const userCreate = (data?: object) => request({
  url: `${path}/user/userCreate`,
  method: 'Post',
  data,
});

export const userPasswordPut = (data?: object) => request({
  url: `${path}/user/userPasswordPut`,
  method: 'Put',
  data,
});

export const userAdminCreate = (data?: object) => request({
  url: `${path}/user/userAdminCreate`,
  method: 'Post',
  data,
});

export const userUpdate = ({id, ...data}) => request({
  url: `${path}/user/${id}`,
  method: 'Put',
  params: {
    userDbid: id,
  },
  data,
});

export const userDelete = ({id}) => request({
  url: `${path}/user/${id}`,
  method: 'Delete',
});

export const emailAuthCode = (data?: object) => request({
  url: `${path}/user/emailAuthCode`,
  method: 'Post',
  data,
});

export const versionGET = (data?: object) => request({
  url: `${path}/version`,
  method: 'Get',
  params: data,
});
